import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from '../../common/withRouter';
import {
  ButtonOBSOLETED,
  Notification,
  Message,
  Loader
} from '../../web.common';
import { CSVLink } from 'react-csv';
import axios from 'axios';
import { LayoutContext } from '../layout/siteLayout';
import PageTop from '../layout/PageTop';
import withApi from '../higherOrderComponents/withApi';
import AsyncSelect from "react-select/async";
import { v4 as uuidv4 } from 'uuid';

const containerStyle = {
  width: '50%',
  margin: 'auto',
  backgroundColor: 'white',
  border: "1px solid #e5e5e5",
  padding: "1.2rem"
};
const formSpanStyle = {
  display: "table-cell",
};
const rowStyle = {
  display: "table",
  width: "100%",
  margin: "auto auto 0px",
  position: "relative"
};
const formLabelStyle = {
  display: "table-cell",
  width: "30%",
  whiteSpace: "nowrap",
  fontWeight: "bold",
  verticalAlign: "top",
};
const inputStyle = {
  marginLeft: "-40%"
};

const SalesReportInternal = ({ api }) => {

  const [downloading, setDownloading] = useState(null);
  const [editedNotification, setNotification] = useState(null);
  const [facility, setFacility] = useState(null);
  const [from, setFrom] = useState(null);
  const [to, setTo] = useState(null);
  const [includeCancellations, setIncludeCancellations] = useState(false);
  const [isByActivityDate, setIsByActivityDate] = useState(false);

  const lookupFacility = (value) => {
    const result = api.facilities.lookupByName(value);
    return result;
  }

  const validateForm = () => {

    const emptyFields = [];
    let response = {
      success: false,
      type: 'error',
      message: ''
    };

    if (from == null) {
      emptyFields.push('From');
    }
    if (to == null) {
      emptyFields.push('To');
    }

    if (from >= '2024-07-01') {
      response.success = false;
      response.message = 'The From field must be a date before 1 July 2024';
      return response;
    }

    if (to > '2024-07-02') {
      response.success = false;
      response.message = 'Field To must be a date no later than 1 July 2024';
      return response;
    }

    if (to < from) {
      response.success = false;
      response.message = 'The To field must be a date after the From field';
      return response;
    }

    if (emptyFields.length == 1) {
      response.message = `Unable to send the request. The ${emptyFields} field is mandatory.`
    } else if (emptyFields.length > 1) {
      response.message = `Unable to send the request. ${emptyFields.join(', ')} are mandatory.`
    } else {
      response.success = true;
      response.type = 'success';
    }

    return response;
  }

  const generateSalesReport = async (event) => {

    const validationResponse = validateForm();
    if (validationResponse.success == false) {
      event.preventDefault();
      setNotification(new Message(validationResponse.type, validationResponse.message));
      return;
    }
    try {
      setDownloading(`Retrieving data from ${from} to ${to} ...`);
      var data = await api.products.generateSalesReportOld({
        from: from,
        to: to,
        facility: facility,
        includeCancellations: includeCancellations,
        byActivityDate: isByActivityDate
      });

      downloadData(data);

      setNotification(new Message('success', 'Download is ready'));
    } catch (e) {
      setNotification(new Message('error', 'Error while retrieving data'));
      console.error(e);
    } finally {
      setDownloading(null);
    }
  }

  const downloadData = (data) => {
    const reportGuid = uuidv4();
    var binaryData = [];
    binaryData.push(data);
    const blob = new Blob(binaryData, { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = `${reportGuid}.csv`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
  }

  return (
    <LayoutContext.Consumer>
      {() => (
        <React.Fragment>
          <Notification newMessage={editedNotification} />
          <PageTop
            documentTitle='Historical Sales Report'
            documentDescription='Sales Report from 2014 to 1 July 2024'
          />

          <h2 className='main-page-header'>
            Historical Sales Report
          </h2>
          <h4 className='main-page-header'>Use this report from 2014 to 1 July 2024</h4>

          <div style={containerStyle}>
            <div style={rowStyle}>
              <label style={formLabelStyle} for="report-from">From</label>
              <span style={formSpanStyle}>
                <input type="date" id="report-from" onChange={({ target }) => {
                  console.log(`from ${target.value}`);
                  setFrom(target.value);
                }} />
              </span>
            </div>
            <br />
            <div style={rowStyle}>
              <label style={formLabelStyle} for="report-to">To</label>
              <span style={formSpanStyle}>
                <input type="date" id="report-to" onChange={({ target }) => {
                  console.log(`to ${target.value}`);
                  setTo(target.value);
                }} />
              </span>
            </div>
            <br />
            <div style={rowStyle}>
              <label style={formLabelStyle} for="facility">
                Facility
              </label>
              <span style={formSpanStyle}>
                <AsyncSelect
                  className="react-select-filters-section"
                  classNamePrefix="react-select-filters-section-prefix"
                  defaultOptions
                  value={facility}
                  isClearable={true}
                  cacheOptions
                  onChange={(selection) => {
                    console.log(selection);
                    setFacility(selection);
                  }
                  }
                  loadOptions={async (inputValue) => lookupFacility(inputValue)}
                ></AsyncSelect>
              </span>
            </div>
            <br />
            <div style={rowStyle}>
              <label style={formLabelStyle} for="by-activity-date">
                By Activity Date
              </label>
              <span style={formSpanStyle}>
                <input
                  style={inputStyle}
                  type="checkbox"
                  checked={isByActivityDate}
                  onChange={({ target }) => {
                    setIsByActivityDate(target.checked);
                  }}
                />
              </span>
            </div>
            <br />
            <div style={rowStyle}>
              <label style={formLabelStyle} for="include-cancellations">
                Include Cancellations
              </label>
              <span style={formSpanStyle}>
                <input
                  style={inputStyle}
                  type="checkbox"
                  checked={includeCancellations}
                  onChange={({ target }) => {
                    setIncludeCancellations(target.checked);
                  }}
                />
              </span>
            </div>
            <br />
          </div>
          <br />
          <div style={{ 'display': 'flex', 'justifyContent': 'center', 'marginTop': '2%' }}>
            <div >
              {downloading ?
                <ButtonOBSOLETED
                  type="submit"
                  buttonContent="Get Report"
                  disabled={true}
                /> :
                <ButtonOBSOLETED
                  type="submit"
                  buttonContent="Get Report"
                  onClick={async (e) => {
                    e.preventDefault();
                    await generateSalesReport(e);
                  }} />
              }
            </div>
          </div>
          {
            <p><br /><br /><b>{downloading ? downloading : ''}</b></p>
          }
          {downloading && <Loader />}
        </React.Fragment>
      )}
    </LayoutContext.Consumer>
  );
}

const SalesReport = withRouter(withApi(
  connect(({ user }) => ({ isLoggedIn: !!user }), {})(SalesReportInternal)
));

SalesReport.requiresLogin = true;
SalesReport.propTypes = { isLoggedIn: PropTypes.bool };

export default SalesReport;